import { render, staticRenderFns } from "./sms-info-body.vue?vue&type=template&id=e533e04e&scoped=true"
import script from "./sms-info-body.vue?vue&type=script&lang=js"
export * from "./sms-info-body.vue?vue&type=script&lang=js"
import style0 from "./sms-info-body.vue?vue&type=style&index=0&id=e533e04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e533e04e",
  null
  
)

export default component.exports